
    import '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/chat-providers/deep-seek-chat-provider.md?watch=parent';
    export const demoIndex = {
  ids: [],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/opt/buildhome/repo/packages/x/docs/x-sdk/demos/chat-providers/deep-seek-chat-provider.md?type=demo')
};